import { useQuery } from '@tanstack/react-query';
import { CommentId } from 'models/Comment';
import { commentQuery } from 'networking/mindfeed/queries/comments';

export const useComment = (
  commentId: CommentId,
  { enabled = true }: { enabled?: boolean } = {},
) => {
  return useQuery({ ...commentQuery(commentId), enabled });
};
